// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3EenS","title":"Info_title__3R65Q","links":"Info_links__Tj2zj","link":"Info_link__2eEZs","logo":"Info_logo__2k7k8"};